import { uniq } from 'lodash';

import { useProductOptionContext } from '../../context/ProductOptionProvider';
import { productPriceCalculator } from '../../core/price-summary.core';
import { useZigzinEstimateShippingInfo } from '../../query/useZigzinEstimamteShippingInfo';
import { ProductOptionConfig } from '../../type/common.type';
import {
  checkZigzinOrVendorFlexDeliveryType,
  checkZigzinOrVendorFlexFulfillmentType,
} from '../../util/checkers/zigzin-checker';

interface Props {
  config: ProductOptionConfig;
}

export const usePriceSummary = ({ config }: Props) => {
  const { state } = useProductOptionContext();
  const product = state.option.info?.catalog_product;

  const selectedZigzinList = uniq(
    state.item_cards.list.map((o) => checkZigzinOrVendorFlexDeliveryType(o.delivery_type)),
  );

  const isZigzinProduct = checkZigzinOrVendorFlexFulfillmentType(product?.fulfillment_type ?? null);

  const hasMatchingZigzinProduct = !!selectedZigzinList.filter((o) => o).length;

  const zigzinProductId = isZigzinProduct ? product?.id : product?.matching_catalog_product_info?.id;

  const zigzinFinalPrice = isZigzinProduct
    ? product?.product_price.final_discount_info.discount_price
    : product?.matching_catalog_product_info?.product_price.final_discount_info.discount_price;

  const { pdp_zigzin_shipping_base_info } = useZigzinEstimateShippingInfo({
    catalog_product_id: zigzinProductId ?? '',
    final_price: zigzinFinalPrice ?? 0,
    enabled: isZigzinProduct || Boolean(product?.matching_catalog_product_info && hasMatchingZigzinProduct),
  });

  const priceSummary = productPriceCalculator({
    disabledCoupon: config?.disabledCoupon,
    option_data_info: state.option.info,
    item_card_list: state.item_cards.list,
    zigzin_shipping_base_info: pdp_zigzin_shipping_base_info,
  });

  return {
    disabledCoupon: config?.disabledCoupon,
    priceSummary,
  };
};
